import React, { useState } from "react";
import { StyleSheet, View } from "react-native";

import {
  Text,
  Input,
  Button,
  LoadingBox,
  InputLabel,
  CountryPicker,
  ProvincePicker,
} from "components";

import { useForm, Controller } from "react-hook-form";
import { strings } from "assets/constants";
import css from "styles";
import { useCreateCity } from "clients/apis";

const CreateCity = () => {
  const [countryId, setCountryId] = useState();
  const {
    control,
    reset,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateCityReqT>({
    defaultValues: {
      zone_id: "",
      name: "",
      code: "",
    },
  });

  const createCityMut = useCreateCity();
  const _onSubmit = () => {
    createCityMut.mutate(getValues(), {
      onSettled(data, error) {
        if (!error) {
          // console.log(data);
          return;
        }

        // console.log(error);
      },
    });
  };

  return (
    <View style={styles.container}>
      <Text weight="extraBold" style={styles.title}>
        {strings.create_new_city}
      </Text>

      <>
        <InputLabel label={strings.country} />
        <CountryPicker onSelect={(c) => setCountryId(c.id)} />
      </>

      <>
        <InputLabel label={strings.zone} />
        <Controller
          control={control}
          name="zone_id"
          rules={{ required: { value: true, message: strings.fill_input } }}
          render={({ field: { value, onChange } }) => (
            <ProvincePicker id={countryId} onSelect={(c) => onChange(c?.id)} />
          )}
        />
      </>

      <View style={css.rRowCenterAlignSpaceBetween}>
        <View style={{ width: "49%" }}>
          <InputLabel label={strings.city_name} />
          <Controller
            control={control}
            name="name"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <Input
                value={value}
                onChangeText={onChange}
                icon={{ name: "edit-2" }}
                placeholder={strings.city_name}
                error={errors?.name?.message}
              />
            )}
          />
        </View>

        <View style={{ width: "49%" }}>
          <InputLabel label={strings.city_code} />
          <Controller
            control={control}
            name="code"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <Input
                value={String(value)}
                onChangeText={onChange}
                icon={{ name: "edit-2" }}
                placeholder={strings.city_code}
                error={errors?.code?.message}
              />
            )}
          />
        </View>
      </View>

      <Button
        mt={15}
        width={120}
        title={{ value: strings.create }}
        onPress={handleSubmit(_onSubmit)}
      />
      {createCityMut?.isLoading && <LoadingBox />}
    </View>
  );
};

export default CreateCity;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 15,
    paddingVertical: 20,
  },

  title: { marginBottom: 7 },
});
